/**
 * Iter XX.295 — React binding for the RevenueCat purchase-availability
 * state machine (commercial P0).
 *
 * Returns { state, reason } and re-renders the component whenever the
 * availability settles or changes:
 *
 *   state: 'initializing' | 'ready' | 'unavailable' | 'not_native'
 *   reason: precise configure reason, e.g. 'rc_key_missing',
 *           'rc_sdk_unavailable', 'rc_configure_error', 'rc_ready',
 *           'rc_configuring', 'rc_not_native'
 *
 * On web the state is always 'not_native' — web purchase surfaces keep
 * their existing Stripe behaviour untouched.
 */
import { useEffect, useState } from "react";
import {
  getNativePurchaseAvailability,
  onPurchaseAvailabilityChanged,
} from "./revenueCat";

export function useNativePurchaseAvailability() {
  const [availability, setAvailability] = useState(
    getNativePurchaseAvailability
  );
  useEffect(
    () => onPurchaseAvailabilityChanged(setAvailability),
    []
  );
  return availability;
}

export default useNativePurchaseAvailability;
